// project import
import dashboard from './dashboard';
import admin from './admin';
import cms from './cms';
import partner from './partner';
import cronjob from './cronjob';
import chat from './chat';
import utilities from './utilities';
import property from './property';
import thriftshop from './thriftshop';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    dashboard,
    admin,
    cms,
    cronjob,
    partner,
    chat,
    utilities,
    property,
    thriftshop,
};

export default menuItems;
